import React from 'react';
import useStyles from 'hooks/useStyles';
import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import Link from 'components/Link';

import {
  REGULAR_CLASS_TYPE,
  COURSE_TYPE,
  COURSE,
  LIVE,
} from 'constants/routingPath';
import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';
import styles from './CtaFooter.scss';

function CtaFooter({ contentType }) {
  const { t } = useTranslation(['instructorProfile']);
  useStyles(styles);
  const getOfficialSiteURL = useGetOfficialSiteURL();

  const ctaLinkMapping = {
    [COURSE_TYPE]: getOfficialSiteURL(COURSE),
    [REGULAR_CLASS_TYPE]: getOfficialSiteURL(LIVE),
  };

  const ctaTextMapping = {
    [COURSE_TYPE]: t(`instructorList.footerBanner.courseCta`),
    [REGULAR_CLASS_TYPE]: t('instructorList.footerBanner.regularClassCta'),
  };

  return (
    <div className={styles.root}>
      <h4 className={styles.title}>{t('instructorList.footerBanner.title')}</h4>
      <Link to={ctaLinkMapping[contentType]}>
        <Button reversed>{ctaTextMapping[contentType]}</Button>
      </Link>
    </div>
  );
}

CtaFooter.propTypes = {
  contentType: string.isRequired,
};

export default CtaFooter;
